import { render, staticRenderFns } from "./addSprInfo.vue?vue&type=template&id=af555af0&"
import script from "./addSprInfo.vue?vue&type=script&lang=js&"
export * from "./addSprInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports